<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="fm-title">Contents</p>
<p class="toca"><a href="#/xhtml/07_Preface">Preface</a></p>
<p class="toca"><a href="#/xhtml/08_Acknowledgements">Acknowledgements</a></p>
<p class="toca"><a href="#/xhtml/09_Introduction">Introduction</a></p>
<p class="toc1a"><span href="#/xhtml/10_Chapter01" title="Link target outside of Sample">Chapter One</span></p>
<p class="toc2"><span href="#/xhtml/10_Chapter01" title="Link target outside of Sample">The Outbreak of War, July–October 1937</span></p>
<p class="toc1"><span href="#/xhtml/11_Chapter02" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc2"><span href="#/xhtml/11_Chapter02" title="Link target outside of Sample">The Destruction of Chiang Kai-shek’s Armies, August–December 1937</span></p>
<p class="toc1"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc2"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample">‘The Decisive Year’, January–June 1938</span></p>
<p class="toc1"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc2"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample">‘Delayed Defeat’, July–December 1938</span></p>
<p class="toc1"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc2"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample">Japan Triumphant, 1939–42</span></p>
<p class="toc1"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">Chapter Six</span></p>
<p class="toc2"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">China’s Guerrilla War, 1937–45</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="toc2"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">The Chinese Army in Burma, 1942–5</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample">China’s Final Victory, 1943–5</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?8351c132